module.exports = __webpack_public_path__ + "img/administration_block.ad380efa.svg";